import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/router/auth'

Vue.use(Router)

function checkSession (to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check()
      .then(res => {
        if (res) {
          next()
        } else {
          next('/login')
        }
      })
  }
  else {
    next('/login')
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: () => import(
        '@/pages/errors/404.vue'
      )
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(`@/pages/Login.vue`),
      beforeEnter (to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check()
            .then(res => {
              if (res) {
                next('/home')
              } else {
                next()
              }
            })
        }
        else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'Root',
      redirect: {
        name: 'Home'
      },
      component: () => import(`@/pages/Root.vue`),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import(`@/pages/Home.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/usuarios',
          name: 'User',
          component: () => import(`@/pages/User.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/empresas',
          name: 'Company',
          component: () => import(`@/pages/Company.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/fuentes-emisiones',
          name: 'EmissionSource',
          component: () => import(`@/pages/EmissionSource.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/sectores-profesionales',
          name: 'ProfessionalSector',
          component: () => import(`@/pages/ProfessionalSector.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/catalogos',
          name: 'Catalogue',
          component: () => import(`@/pages/Catalogue.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/plantillas',
          name: 'Template',
          component: () => import(`@/pages/Template.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/importacion-masiva',
          name: 'MassiveImport',
          component: () => import(`@/pages/MassiveImport.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/proveedores',
          name: 'Supplier',
          component: () => import(`@/pages/Supplier.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/formularios',
          name: 'Form',
          component: () => import(`@/pages/Form.vue`),
          beforeEnter: checkSession
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to, from) => {
});

export default router
